import Vue from 'vue'
import { MessageBox } from 'element-ui'

const temp = new Vue()

const ContactMarket = () => {
  const template = "<div><img src='/static/images/business-qrcode.png' style=\"width:180px;height:180px\"></img><p style=\"margin-top: 10px; margin-bottom: -24px; color: #666;\">销售电话: 18602727347</p></div>"
  const renderer = Vue.compile(template)

  MessageBox.alert(temp.$createElement(renderer), { title: '联系销售', customClass: 'center', showClose: false })
}

const ContactCS = () => {
  const template = '<div style="text-align: left;"><p>客服QQ群：461571276</p><p>客服邮箱：support@ppj.io</p></div>'
  const renderer = Vue.compile(template)

  MessageBox.alert(temp.$createElement(renderer), { title: '联系客服', customClass: 'center', showClose: false })
}

const ContactApiApplication = () => {
  const template = "<div style=\"margin-bottom: -1em;\"><h1>提交成功</h1><p style=\"color: #333;margin: 2em 0 1em;\">请微信联系客服开通权限</p><img src='/static/images/business-qrcode.png' style=\"width:180px;height:180px\"></img></div>"
  const renderer = Vue.compile(template)

  MessageBox.alert(temp.$createElement(renderer), { title: ' ', customClass: 'center noheader', showClose: false })
}

const install = (Vue, opts = {}) => {
  Vue.prototype.$contactMarket = ContactMarket
  Vue.prototype.$contactCS = ContactCS
  Vue.prototype.$contactApiApplication = ContactApiApplication
}

module.exports = {
  install
}



// WEBPACK FOOTER //
// ./src/plugins/contacts.alert.js